import { Box, Grid, Typography } from '@mui/material';
import CustomSwitch from 'components/Inputs/AlertKpi/CustomSwitch';
import CustomTextFieldIndex from 'components/Inputs/AlertKpi/CustomTextFieldIndex';

const AutoResolutionRuleTab = ({ formData, setFormData }: any) => {
    return (
        <Box sx={{ mt: 3, p: 2, borderRadius: '8px', width: '100%' }}>
            <Typography variant="body2" sx={{ opacity: 0.7, mb: 2 }} color="textLight.main">
                ⓘ This section is to setup auto-resolution rules.
            </Typography>

            <Grid container spacing={2}>
                <Grid item xs={10}>
                    <CustomSwitch
                        isEnabled={formData.autoResolutionRuleConfig?.isEnabled}
                        onChange={(checked) =>
                            setFormData({
                                ...formData,
                                autoResolutionRuleConfig: {
                                    ...formData.autoResolutionRuleConfig,
                                    isEnabled: checked,
                                },
                            })
                        }
                        label="Auto - Resolution Rule"
                    />
                </Grid>

                <Grid item xs={10} md={3}>
                    <CustomTextFieldIndex
                        label="Variable Name*"
                        variant="outlined"
                        size="small"
                        value={formData.autoResolutionRuleConfig?.queryVariableName ?? ''}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => 
                            setFormData({ 
                                ...formData, 
                                autoResolutionRuleConfig: { 
                                    ...formData.autoResolutionRuleConfig, 
                                    queryVariableName: e.target.value 
                                } 
                            })
                        }
                    />
                </Grid>

                <Grid item xs={10} md={3}>
                    <CustomTextFieldIndex
                        label="Variable Value*"
                        variant="outlined"
                        size="small"
                        value={formData.autoResolutionRuleConfig?.queryVariableValue ?? ''}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => 
                            setFormData({ 
                                ...formData, 
                                autoResolutionRuleConfig: { 
                                    ...formData.autoResolutionRuleConfig, 
                                    queryVariableValue: e.target.value 
                                } 
                            })
                        }
                    />
                </Grid>

                <Grid item xs={false} md={6} />

                <Grid item xs={10} md={6} sx={{ mt: 3 }}>
                    <CustomTextFieldIndex
                        label="Email Body*"
                        variant="outlined"
                        size="small"
                        multiline
                        rows={5}
                        value={formData.autoResolutionRuleConfig?.emailBody ?? ''}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => 
                            setFormData({ 
                                ...formData, 
                                autoResolutionRuleConfig: { 
                                    ...formData.autoResolutionRuleConfig, 
                                    emailBody: e.target.value 
                                } 
                            })
                        }
                        sx={{
                            '& .MuiInputBase-input': {
                                color: '#A9ADCB !important', 
                            }
                        }}
                    />
                </Grid>
            </Grid>
        </Box>
    );
};
export default AutoResolutionRuleTab;